import { DatabaseEntities } from "../../../common/models/database-entities.model";

export class Warehouses extends DatabaseEntities<Warehouses> {
    name?: string;
}
